function showLoader2() {
    $('#loader2').removeClass('fade-out');
}

function hideLoader2() {
    $('#loader2').addClass('fade-out');
}

// Dock/panel toggle + View-modal handling moved to admin-panel.js (shared
// with the chapter page).
document.addEventListener('DOMContentLoaded', function () {
    // Hero description: the More/Less toggle only appears when the clamped
    // content actually overflows. Re-measured after webfonts/load/resize,
    // since the fallback-font layout can fit lines the real font won't.
    // Labels come from data-* attributes (Blade owns the translations).
    const content = document.getElementById('heroAboutContent');
    const moreBtn = document.getElementById('heroAboutMore');

    if (content && moreBtn) {
        const syncMoreBtn = () => {
            if (content.classList.contains('is-expanded')) return;
            const overflowing = content.scrollHeight > content.clientHeight + 2;
            moreBtn.hidden = !overflowing;
            // Drives the friendly bottom fade — only shown when actually clamped.
            content.classList.toggle('has-fade', overflowing);
        };

        // Smooth expand/collapse via FLIP: measure the start height, flip the
        // class, measure the target, then animate max-height between them and
        // hand control back to the (fluid) flex layout once settled.
        let animating = false;
        moreBtn.addEventListener('click', () => {
            if (animating) return;
            animating = true;
            const expand = !content.classList.contains('is-expanded');
            const startH = content.getBoundingClientRect().height;

            content.classList.toggle('is-expanded', expand);
            content.style.overflow = 'hidden';
            // Target height: full when expanding ('none'); the CSS clamp when
            // collapsing ('' hands back to the stylesheet's max-height).
            content.style.maxHeight = expand ? 'none' : '';
            const endH = content.getBoundingClientRect().height;

            content.style.maxHeight = startH + 'px';
            void content.offsetHeight; // reflow so the next value transitions
            content.style.maxHeight = endH + 'px';

            let settled = false;
            const settle = () => {
                if (settled) return;
                settled = true;
                content.removeEventListener('transitionend', onEnd);
                content.style.maxHeight = '';   // hand height back to the flex layout
                content.style.overflow = '';
                animating = false;
                syncMoreBtn();
            };
            const onEnd = (e) => {
                if (e.target === content && e.propertyName === 'max-height') settle();
            };
            content.addEventListener('transitionend', onEnd);
            setTimeout(settle, 400); // fallback if transitionend never fires

            const label = expand ? moreBtn.dataset.labelLess : moreBtn.dataset.labelMore;
            moreBtn.innerHTML = label + (expand ? ' ▴' : ' ▾');
        });

        syncMoreBtn();
        window.addEventListener('load', syncMoreBtn);
        window.addEventListener('resize', syncMoreBtn);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncMoreBtn);
    }
});


